import type { GALLERY_DATA, GALLERY_PARAMS } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

const DEFAULT_GALLERY_PARAMS_DEVICE = () => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_GALLERY_PARAMS = (): GALLERY_PARAMS => ({
  pc: DEFAULT_GALLERY_PARAMS_DEVICE(),
  tablet: DEFAULT_GALLERY_PARAMS_DEVICE(),
  mobile: DEFAULT_GALLERY_PARAMS_DEVICE(),
})

export const DEFAULT_GALLERY_DATA = (): GALLERY_DATA => ({
  id: null,
  classes: null,
  type: 'gallery',
  data: {
    value: null,
    numVisible: 5,
  },
})